import React from 'react';
import { Link } from 'react-router-dom';
import './Imprint.css';

function Imprint() {
  return (
    <div className="imprint">
      <Link to="/" className="back-to-home">← Back to Home</Link>
      <div className="imprint-container">
        <header className="imprint-header">
          <h1 className="imprint-title">Legal Notice / Imprint 2025</h1>
        </header>

        <div className="imprint-content">
          <section className="imprint-section">
            <div className="imprint-text">
              <p><strong>BonusClub LLC</strong></p>
              <p>7901 4th St N STE 300</p>
              <p>St. Petersburg, Florida 33702</p>
              <p>United States of America</p>
              <br />
              <p>Represented by Managing Director Julian Propst</p>
              <br />
              <p><strong>Service of legal documents:</strong></p>
              <p>Northwest Registered Agent Service, Inc.</p>
              <p>7901 4th St N STE 300</p>
              <p>St. Petersburg, FL 33702</p>
              <p>USA</p>
              <br />
              <p>Registered in Florida, USA</p>
              <p>© 2025 BonusClub LLC</p>
              <br />
              <p>Personal website of Julian Propst – <a href="https://www.julianpropst.com" target="_blank" rel="noopener noreferrer">julianpropst.com</a></p>
              <br />
              <p><em>BonusClub operates globally from the United States and does not target users in any specific country or jurisdiction.</em></p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default Imprint; 